import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const removeFavoriteForm = async (formId: string): Promise<boolean> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation removeFavoriteForm($formId: String!) {
        removeFavoriteForm(formId: $formId)
      }
    `),
    variables: {
      formId,
    },
  });

  return response.data?.removeFavoriteForm ?? false;
};
